/// <reference types="vite-plugin-pwa/client" />
import React, { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'react-hot-toast';
import { Button } from '@mui/material';
import { RefreshCw } from 'lucide-react';

export const PWAUpdater: React.FC = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) {
        void r.update();
        setInterval(() => {
          void r.update();
        }, 60 * 60 * 1000);
      }
    },
    onRegisterError(error) {
      console.error('Erro ao registrar Service Worker PWA', error);
    },
  });

  useEffect(() => {
    if (needRefresh) {
      toast(
        (t) => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
            <span style={{ fontWeight: '500' }}>
              Uma nova versão do sistema está disponível!
            </span>
            <span style={{ fontSize: '0.875rem', color: '#666' }}>
              Atualize para usar os novos recursos e correções.
            </span>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<RefreshCw size={16} />}
              onClick={() => {
                toast.dismiss(t.id);
                updateServiceWorker(true);
              }}
              style={{ marginTop: '8px', alignSelf: 'flex-end' }}
            >
              Atualizar Agora
            </Button>
          </div>
        ),
        {
          duration: Infinity, // Toast não some até o usuário clicar
          position: 'bottom-right',
          style: {
            minWidth: '300px',
          }
        }
      );
    }
  }, [needRefresh, updateServiceWorker]);

  return null; // Este componente não renderiza nada diretamente na tela
};
